webpackJsonp([186063380969677],{

/***/ "./src/components/BlogListItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkStyle = {
	  color: _colors2.default.dnaDark
	};
	
	var BlogListItem = function (_Component) {
	  _inherits(BlogListItem, _Component);
	
	  function BlogListItem() {
	    _classCallCheck(this, BlogListItem);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BlogListItem.prototype.render = function render() {
	    return _react2.default.createElement(
	      'li',
	      { style: { display: 'inline-block' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: this.props.to,
	            style: {
	              textShadow: 'none',
	              backgroundImage: 'none',
	              color: 'black'
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: linkStyle },
	            this.props.title
	          )
	        ),
	        _react2.default.createElement(
	          'small',
	          { style: { color: _colors2.default.dnaPurple } },
	          this.props.date,
	          ' - ',
	          this.props.timeToRead,
	          ' min read'
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.props.excerpt } })
	      )
	    );
	  };
	
	  return BlogListItem;
	}(_react.Component);
	
	exports.default = BlogListItem;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dna/Documents/WebProjects/DanIsacson/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/blog.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _BlogListItem = __webpack_require__("./src/components/BlogListItem.jsx");
	
	var _BlogListItem2 = _interopRequireDefault(_BlogListItem);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPage = function (_Component) {
	  _inherits(BlogPage, _Component);
	
	  function BlogPage() {
	    _classCallCheck(this, BlogPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BlogPage.prototype.render = function render() {
	    var posts = this.props.data.allMarkdownRemark.edges.map(function (post) {
	      return _react2.default.createElement(_BlogListItem2.default, {
	        key: post.node.frontmatter.path,
	        to: post.node.frontmatter.path,
	        title: post.node.frontmatter.title,
	        date: post.node.frontmatter.date,
	        excerpt: post.node.excerpt,
	        timeToRead: post.node.timeToRead
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: "Dan Isacson - Blog" },
	        _react2.default.createElement('meta', { name: 'description', content: 'Dan Isacson\'s blog' })
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Blog'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I occasionally post things related to programming and software development here. You may somtimes also find unrelated random posts!'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { style: { marginLeft: 0 } },
	        posts
	      )
	    );
	  };
	
	  return BlogPage;
	}(_react.Component);
	
	exports.default = BlogPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-jsx-2ed26742c7a11ad126a6.js